<template >
    <div id="app">
        <router-view/>
        <banner/>
    </div>
</template>

<script>
import banner from './components/banner.vue'
	export default {
        components: { banner },
        name: 'app'
    }
</script>

<style>
    body {
        overflow: hidden;
        background-color: #ffffff;
        margin: 0;
        padding: 0;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        height: auto !important;
    }

    ::-webkit-scrollbar{
        display: block !important;
        background: transparent;
        width: 6px;
        height: 6px;
    }

    ::-webkit-scrollbar-thumb {
        background: #5E5E7A;
        border-radius: 10px;
        width: 6px;
    }

    .el-tooltip__popper.is-dark{
        background-color: #0d1424;
        color: #b5c5de;
        padding: 2px 4px;
        font-size: 12.5px;
        font-weight: 600;
    }

    .el-tooltip__popper.is-dark .popper__arrow{
        display: none;
    }

    .btn-action{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border-radius: 4px;
        cursor: pointer;
    }

    .btn-action:hover{
        background-color: rgba(255, 255, 255, .1);
    }

    .disappear{
        visibility: hidden;
    }

    .el-button--mini{
        padding: 5px 10px;
    }

    .room-topic-tooltip-class{
        max-width: 300px;
    }

    .share-tooltip{
        white-space: nowrap;
    }

    .el-notification {
        background-color: #2A2A3D;
        border: 1px solid #2A2A3D;
        border-radius: 8px;
        padding: 14px 0 16px 24px;
        min-width: 310px;
        max-width: 100%;
        box-sizing: border-box;
    }

    .el-notification__content {
        text-align: left;
    }

    .el-notification .el-notification__title {
        font-weight: 600;
        font-size: 18px;
        line-height: 23px;
        color: #E7E6FA; 
    }

    .el-dialog__header,
    .el-dialog__body,
    .el-dialog__footer {
        background-color: #2A2A3D;
        color: #E7E6FA;
    }

    .el-dialog__header {
        text-align: left;
    }

    .el-dialog__title {
        color: #E7E6FA;
        text-align: left;
    }

    button.el-button--default,
    button.el-button--default:hover,
    button.el-button--default:active {
        color: #E7E6FA;
        border-radius: 8px;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        padding: 8px 10px;
        min-width: 88px;
        height: 40px;
    }

    button.el-button--default {
        border: 1px solid #E7E6FA;
        background: #2A2A3D;
    }

    button.el-button--default:hover {
        background: rgba(255, 255, 255, 0.11);
        border: 1px solid #E7E6FA;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), inset 0px 0px 8px rgba(218, 217, 236, 0.25);
    }

    button.el-button--default:active,
    button.el-button--default:focus {
        border-color: initial;
        background: rgba(255, 255, 255, 0.15);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), inset 0px 0px 8px rgba(218, 217, 236, 0.5);
    }

    button.el-button--primary,
    button.el-button--primary:hover,
    button.el-button--primary:active {
        color: #E7E6FA;
        border-radius: 8px;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        padding: 8px 10px;
        min-width: 88px;
        height: 40px;
    }

    button.el-button--primary {
        border: 1px solid #6F26DF;
        background: #6F26DF;
    }

    button.el-button--primary:hover {
        background: #A266FF;
        border: 1px solid #A266FF;
        box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2);
    }

    button.el-button--primary:active,
    button.el-button--primary:focus {
        background: #A266FF;
        border: 1px solid #6817E6;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), inset 0px 0px 8px rgba(0, 0, 0, 0.45);
    }

    button.el-button--text,
    button.el-button--text:hover,
    button.el-button--text:focus,
    button.el-button--text:active {
        color: #50C6DF;
    }

    button.el-button--text:hover,
    button.el-button--text:active,
    button.el-button--text:focus {
        text-decoration: underline;
    }

    ul.el-dropdown-menu {
        background-color: #1c1c29 !important;
        border: none;
    }

    ul.el-dropdown-menu li.el-dropdown-menu__item {
        color: #E7E6FA;
    }
    ul.el-dropdown-menu li.el-dropdown-menu__item:hover {
        background-color: #aeaafa;
        color: #1c1c29;
    }
    ul.el-dropdown-menu.el-popper div.popper__arrow,
    ul.el-dropdown-menu.el-popper div.popper__arrow::after {
        border-bottom-color: #1c1c29;
    }

    @media (max-width: 767px) {
        .el-notification {
            z-index: 11 !important;
        }
    }

    @media (hover: none) {
        .el-notification {
            z-index: 11 !important;
        }
    }

</style>